import { Check } from "lucide-react";
import { EXPERTISE } from "@/data/site";
import { Reveal, SectionHeading } from "@/components/Reveal";
import WhatsAppCTA from "@/components/WhatsAppCTA";

export default function Expertise() {
  return (
    <div data-testid="expertise-page" className="bg-ivory">
      <section className="noise-overlay bg-obsidian pb-20 pt-40">
        <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
          <SectionHeading
            light
            align="left"
            eyebrow="Our Expertise"
            title="Every Discipline of Architectural Stone"
            description="Ten crafts, practised daily in our Udaipur studio — from monumental murals to the smallest carved gift."
          />
        </div>
      </section>

      <section className="py-20 sm:py-28">
        <div className="mx-auto max-w-7xl space-y-24 px-6 sm:px-12 lg:space-y-32 lg:px-20">
          {EXPERTISE.map((e, i) => (
            <div
              key={e.slug}
              id={e.slug}
              data-testid={`expertise-detail-${e.slug}`}
              className="grid scroll-mt-28 items-center gap-10 lg:grid-cols-2 lg:gap-16"
            >
              <Reveal className={i % 2 === 1 ? "lg:order-2" : ""}>
                <div className="group spotlight-frame overflow-hidden rounded-2xl">
                  <img
                    src={e.image}
                    alt={e.title}
                    loading="lazy"
                    className="aspect-[4/3] w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
                  />
                </div>
              </Reveal>
              <Reveal delay={0.12} className={i % 2 === 1 ? "lg:order-1" : ""}>
                <span className="gold-grad-text font-serif text-5xl font-semibold sm:text-6xl">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h2 className="mt-4 font-serif text-3xl font-medium tracking-tight text-stone-900 sm:text-4xl">
                  {e.title}
                </h2>
                <p className="mt-4 max-w-lg text-base leading-relaxed text-stone-600">{e.desc}</p>
                <ul className="mt-7 space-y-3">
                  {e.points.map((pt) => (
                    <li key={pt} className="flex items-center gap-3 text-sm text-stone-700">
                      <span className="rounded-full bg-gold/15 p-1">
                        <Check className="h-3.5 w-3.5 text-gold-dark" />
                      </span>
                      {pt}
                    </li>
                  ))}
                </ul>
                <WhatsAppCTA
                  label="Discuss This Craft"
                  message={`Hello ShilpStones Creations, I would like to discuss ${e.title} for my space.`}
                  context={`Expertise inquiry: ${e.title}`}
                  variant="outline"
                  testId={`expertise-whatsapp-${e.slug}`}
                  className="mt-9 !border-stone-900/25 !text-stone-800 hover:!border-gold hover:!text-gold-dark"
                />
              </Reveal>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
